<template>
  <PageTemplate>
  <div class="in-content-warpper">
    <div class="row">
      <div class="des">
        <div class="title">
          3.馆员工作站系统 型号：HG3
        </div>
        <el-row style="height:30px"></el-row>
        <p>1、条码阅读模块工作原理</p>
        <el-row style="height:10px"></el-row>
        <p style="text-indent:1em;">1）拥有强大的扫描功能，支持一维和二维条码，可扫描纸张、手机和计算机屏幕上的所有条码。</p>
        <el-row style="height:10px"></el-row>
        <p style="text-indent:1em;">2）条码阅读器采用的是窗口式智能感应镜头，只需一次扫描即可准确采集数据；自动为下次扫描做好准备，全面性覆盖式扫描范围，可精准读取任何条码。</p>
        <el-row style="height:10px"></el-row>
        <p>2、图书转换过程中无需键盘操作，RFID标签软件可实现标签快速转速。</p>
        <el-row style="height:10px"></el-row>
        <p>3、标签加工过程有操作提示，录入成功的条码可以显示录入的条码信息，录入失败则在界面提示。</p>
        <el-row style="height:10px"></el-row>
        <p>4、对RFID标签非接触式地进行阅读，能够读取、写入和改写RFID标签，写入标签信息应符合国际、国家相关标准，条码号为必须写入标签的信息。</p>
        <el-row style="height:10px"></el-row>
        <p>5、可依据时间段统计标签加工工作量。</p>
        <el-row style="height:10px"></el-row>
        <p>6、可选择是否更新藏址，并将需要更新藏址的图书进行藏址更新。</p>
        <el-row style="height:10px"></el-row>
        <p>7、抗金属处理，不受金属桌面的影响。</p>
        <p>8、工作频率：13.56MHz。</p>
        <p>9、可通过安装借还软件进行升级，实现借还书功能。</p>
        <p>10、安全触控次数≥3500万次，多点触摸，要求采用超灵敏触控屏,提高画面触控精准度，画面触控无任何死角,轻松触摸。</p>
      </div>
      <div class="img">
        <el-image :src="url3" fit="contain"></el-image>
      </div>
    </div>
  </div>
  </PageTemplate>
</template>
<script>
import PageTemplate from '@/components/PageTemplate'
export default {
  components:{PageTemplate},
  name: 'GuanLi',
  data () {
    return {
      url3: require('../assets/20220822_3.png')
    }
  },
  created () {
  },
  beforeDestroy () {
  }
}
</script>
<style lang="scss">
  .in-content-warpper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    .row {
      width: 100%;
      height: 500px;
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      align-items: center;
      .img {
        width: 500px;
        height: 340px;
        // background-color: #f2f2f2;
        .el-image {
          width: 500px;
          height: 340px;
        }
      }
      .des {
        width: 600px;
        text-align: left;
        margin-left: 100px;
        padding-top: 1;
        line-height: 1.2;
        .title{
          font-size: 25px;
          font-weight: 600;
          color: #000;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/3.vue